import { render, staticRenderFns } from "./EditarPedido.vue?vue&type=template&id=74beb21e&scoped=true"
import script from "./EditarPedido.vue?vue&type=script&lang=js"
export * from "./EditarPedido.vue?vue&type=script&lang=js"
import style0 from "./EditarPedido.vue?vue&type=style&index=0&id=74beb21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74beb21e",
  null
  
)

export default component.exports